import Box from '@liquidweb-dev/undercurrent/Box';
import Skeleton from '@liquidweb-dev/undercurrent/Skeleton';
import Stack from '@liquidweb-dev/undercurrent/Stack';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';
import AssetListItem, { type AssetListItemProps } from '../AssetListItem';

const SkeletonListItem = ({ sx, ...rest }: AssetListItemProps) => (
	<AssetListItem
		sx={combineSx({ padding: 200, gap: 300, alignItems: 'center' }, sx)}
		{...rest}
	>
		<Stack direction="row" sx={{ alignItems: 'center', gap: 200 }}>
			<Skeleton
				variant="circular"
				sx={({ size }) => ({ width: size.md, height: size.md })}
			/>
			<Skeleton
				variant="rounded"
				sx={{ width: '200px', height: ({ size }) => size.xS }}
			/>
		</Stack>

		<Box sx={{ flex: '1 0 0' }} />
		<Stack direction="row" sx={{ alignItems: 'center', gap: 200 }}>
			<Skeleton
				variant="rounded"
				sx={{ width: '80px', height: ({ size }) => size.xS }}
			/>
			<Skeleton
				variant="rounded"
				sx={{ width: '80px', height: ({ size }) => size.xS }}
			/>
			<Skeleton
				variant="rounded"
				sx={{ width: '80px', height: ({ size }) => size.xS }}
			/>
		</Stack>
	</AssetListItem>
);

export default SkeletonListItem;
